import React, { useEffect, useRef, useState } from 'react'
import './style.css'

import { translate } from 'locales'
import type { AppointmentCancelSource } from 'services/analytics/AppointmentCancel/appointmentCancelAnalytics'
import appointmentCancelAnalytics from 'services/analytics/AppointmentCancel/appointmentCancelAnalytics'

import { Button } from '../index'
import {
  CANCEL_REASON_CONNECTION_PATIENT,
  CANCEL_REASON_CONNECTION_PROFESSIONAL,
  CANCEL_REASON_HEALTH_DECISION,
  CANCEL_REASON_NO_SHOW,
  CANCEL_REASON_OTHER,
  CANCEL_REASON_PLATFORM,
  cancelReasonRequiresDetail,
  cancelReasonToAnalyticsKey,
} from './cancelReasons'

interface IAccompaniment {
  state: string
  reason: string
  day: string
}

interface ModalShowProps {
  description?: string
  cancelModal?: boolean
  setDescription?: React.Dispatch<React.SetStateAction<string>>
  closeModal: () => void
  handleConfirm?: () => void
  accompaniment?: IAccompaniment
  customDescription?: string
  setCustomDescription?: React.Dispatch<React.SetStateAction<string>>
  setAccompaniment?: React.Dispatch<React.SetStateAction<IAccompaniment>>
  /** Quando definido, envia eventos Firebase no fluxo de cancelamento. */
  cancelTracking?: {
    schedulingId?: string
    source?: AppointmentCancelSource
  }
}

const CANCEL_RADIO_OPTIONS: { value: string; labelKey: string }[] = [
  { value: CANCEL_REASON_NO_SHOW, labelKey: 'modal.noShow' },
  {
    value: CANCEL_REASON_CONNECTION_PATIENT,
    labelKey: 'modal.connectionPatient',
  },
  {
    value: CANCEL_REASON_CONNECTION_PROFESSIONAL,
    labelKey: 'modal.connectionProfessional',
  },
  { value: CANCEL_REASON_PLATFORM, labelKey: 'modal.platformProblems' },
  {
    value: CANCEL_REASON_HEALTH_DECISION,
    labelKey: 'modal.healthcareDecision',
  },
  { value: CANCEL_REASON_OTHER, labelKey: 'modal.other' },
]

const ModalShow: React.FunctionComponent<ModalShowProps> = ({
  description,
  cancelModal = true,
  setDescription,
  closeModal,
  handleConfirm,
  setCustomDescription,
  customDescription,
  cancelTracking,
}) => {
  const [nextModal, setNextModal] = useState<boolean>(cancelModal)
  const hasLoggedModalView = useRef(false)

  useEffect(() => {
    if (!cancelModal || !cancelTracking) return
    if (hasLoggedModalView.current) return
    hasLoggedModalView.current = true
    appointmentCancelAnalytics.trackCancelModalView({
      schedulingId: cancelTracking.schedulingId,
      source: cancelTracking.source,
    })
  }, [cancelModal, cancelTracking])

  const showDetailField =
    description && cancelReasonRequiresDetail(description)

  const confirmDisabled =
    !description ||
    (cancelReasonRequiresDetail(description) && !customDescription?.trim())

  return (
    <>
      {nextModal ? (
        <>
          <div className="modal-container--cancel-flow">
            <div className="cancel-modal__header">
              <h2 className="cancel-modal__title">
                {translate('modal.cancel')}
              </h2>
              <p className="cancel-modal__subtitle">
                {translate('modal.confirmCancel')}
              </p>
            </div>
            <div className="cancel-modal__options" role="radiogroup">
              {CANCEL_RADIO_OPTIONS.map((opt) => (
                <label key={opt.value} className="cancel-modal__option">
                  <input
                    type="radio"
                    className="cancel-modal__radio-input"
                    name="cancel-reason"
                    value={opt.value}
                    checked={description === opt.value}
                    onChange={() => {
                      if (cancelReasonRequiresDetail(opt.value)) {
                        setCustomDescription?.('')
                      }
                      setDescription?.(opt.value)
                      if (cancelTracking) {
                        appointmentCancelAnalytics.trackCancelReasonSelected({
                          schedulingId: cancelTracking.schedulingId,
                          source: cancelTracking.source,
                          reasonKey: cancelReasonToAnalyticsKey(opt.value),
                        })
                      }
                    }}
                  />
                  <span className="cancel-modal__radio-ui" aria-hidden />
                  <span className="cancel-modal__option-label">
                    {translate(opt.labelKey)}
                  </span>
                </label>
              ))}
            </div>
            {showDetailField && (
              <input
                type="text"
                className="cancel-modal__detail-input"
                placeholder={translate('modal.describe')}
                onChange={(e) => setCustomDescription?.(e.target.value)}
                value={customDescription || ''}
              />
            )}
            <div className="cancel-modal__actions">
              <button
                type="button"
                className="cancel-modal__btn cancel-modal__btn--outline"
                onClick={() => {
                  if (cancelTracking) {
                    appointmentCancelAnalytics.trackCancelDismiss({
                      schedulingId: cancelTracking.schedulingId,
                      source: cancelTracking.source,
                      step: 1,
                    })
                  }
                  closeModal()
                }}
              >
                {translate('modal.close')}
              </button>
              <button
                type="button"
                className="cancel-modal__btn cancel-modal__btn--primary"
                onClick={() => {
                  if (cancelTracking && description) {
                    appointmentCancelAnalytics.trackCancelIntent({
                      schedulingId: cancelTracking.schedulingId,
                      source: cancelTracking.source,
                      reasonKey: cancelReasonToAnalyticsKey(description),
                      hasCustomDetail:
                        cancelReasonRequiresDetail(description) &&
                        Boolean(customDescription?.trim()),
                    })
                  }
                  setNextModal(false)
                }}
                disabled={confirmDisabled}
              >
                {translate('modal.confirmCanceled')}
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="modal-container-cancel">
            <h2>{translate('modal.finishAttendance')}</h2>
            {/* {accompaniment && setAccompaniment && (
              <>
                <div className="modal-select">
                  <p>{translate('modal.finishAccompaniment')}</p>
                  <Select
                    name="confirmated"
                    list={['sim', 'não']}
                    defaultValue={accompaniment?.state}
                    value={accompaniment?.state}
                    onChange={(e: any) => {
                      setAccompaniment({
                        ...accompaniment,
                        state: e.target.value,
                      })
                    }}
                  />
                </div>
                {accompaniment?.state === 'sim' && (
                  <div className="modal-inputs">
                    <label htmlFor="reason">
                      {`${translate('modal.reasonAccompaniment')}:`}
                    </label>
                    <TextArea
                      name="reason"
                      maxlength={250}
                      value={accompaniment.reason}
                      onChange={(e: any) => {
                        setAccompaniment({
                          ...accompaniment,
                          reason: e.target.value,
                        })
                      }}
                    />
                    <label htmlFor="day">
                      {`${translate('modal.dayAccompaniment')}:`}
                    </label>
                    <div className="inputs-times">
                      <div style={{ width: '45%' }}>
                        <Input
                          name="day"
                          type="date"
                          min={new Date().toISOString().split('T')[0]}
                          value={accompaniment.day}
                          onChange={(e: any) => {
                            setAccompaniment({
                              ...accompaniment,
                              day: e.target.value,
                            })
                          }}
                        />
                      </div>
                    </div>
                    {moment(accompaniment?.day).isValid() && !verifyDay && (
                      <span style={{ color: 'red' }}>
                        {translate('modal.dayFuture')}
                      </span>
                    )}
                  </div>
                )}
              </>
            )} */}
            <p className="modal-p">{translate('modal.nextConfirm')}</p>
            <div className="buttons-modal">
              <Button
                type="button"
                color="link-danger"
                onClick={() => {
                  if (cancelTracking) {
                    appointmentCancelAnalytics.trackCancelDismiss({
                      schedulingId: cancelTracking.schedulingId,
                      source: cancelTracking.source,
                      step: 2,
                    })
                  }
                  closeModal()
                }}
                styles={{
                  marginTop: 10,
                  border: '1px solid red',
                  width: 200,
                  marginLeft: 5,
                }}
              >
                {translate('modal.close')}
              </Button>
              <Button
                type="button"
                color="primary"
                // @ts-ignore
                onClick={() => {
                  if (cancelTracking) {
                    appointmentCancelAnalytics.trackCancelFinalConfirmClick({
                      schedulingId: cancelTracking.schedulingId,
                      source: cancelTracking.source,
                    })
                  }
                  handleConfirm?.()
                }}
                styles={{ marginTop: 10, width: 200, marginRight: 5 }}
              >
                {translate('modal.finish')}
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ModalShow
